export const HEADER_HEIGHT_IN_PX = 50;
export const FOOTER_HEIGHT_IN_PX = 90;
export const roundIconStyles = 'flex justify-center flex-grow-0 flex-shrink-0 items-center w-6 h-6 border-solid rounded-full';
export const AUTHORIZATION_FAILED = 'authorizationFailed';
export const CYPRESS_LOCAL_TIMEOUT_TIME = 6000;
